import React from "react";
import {
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
  InputBase,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import TemporaryDrawer from "./left_navigation_menu";
import LoginButton from "./login_button";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: 10,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export default function ButtonAppBar(props) {
  const { history, isAdmin, notVerified } = props;
  const classes = useStyles();
  const Drawer = withRouter(TemporaryDrawer);

  const go_to_search = (e) => {
    if (e.keyCode === 13) {
      history.push({
        pathname: "/Search/1",
        state: { search: e.target.value },
      });
      e.target.value = "";
    }
  };

  function show_search() {
    if (!notVerified && !window.location.pathname.includes("Search")) {
      return (
        <InputBase
          placeholder="Search…"
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
          label={{ "aria-label": "search" }}
          onKeyDown={go_to_search}
        />
      );
    }
  }

  function show_login() {
    if (notVerified) {
      return (
        <LoginButton />
      );
    }
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ background: "#282c34" }}>
        <Toolbar>
          <Drawer isAdmin={isAdmin} />
          <Typography
            variant="h6"
            onClick={() => history.push("/Home")}
            style={{
              cursor: "pointer",
            }}
          >
            Unimog Database 2.0
          </Typography>
          <div className={classes.title}></div>
          {show_search()}
          {show_login()}
        </Toolbar>
      </AppBar>
    </div>
  );
}
